import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, withTheme } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import CompetencyRequirementsIcon from 'components/Icons/CompetencyRequirements';
import LocationIcon from 'components/Icons/Location/Location';
import ShowCardIcon from 'components/Icons/ShowCard/ShowCard';
import SignOutIcon from 'components/Icons/SignOut/SignOut';
import UserGuideIcon from 'components/Icons/UserGuide/UserGuide';

import MediaQuery from 'react-responsive';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Body2 } from 'components/Typography';
import PromptDialog from 'components/PromptDialog';
import { appBarHeightLarge, appBarHeightSmall } from '../shellStyles';
import styles from './styles';

class UserProfileHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuAnchorEl: null,
            confirmLogoutDialogOpen: false
        };
        this.showMenu = this.showMenu.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
        this.clickDelegate = this.clickDelegate.bind(this);
    }

    showMenu(event) {
        this.setState({ menuAnchorEl: event.currentTarget });
    }

    hideMenu() {
        this.setState({ menuAnchorEl: null });
    }

    clickDelegate(func) {
        return () => {
            this.hideMenu();
            func();
        };
    }

    openUserGuide() {
        window.open("https://support.riw.net.au/support/solutions", "_blank");
    }

    cancelLogout = () => {
        this.setState({ confirmLogoutDialogOpen: false });
    };

    handleLogout = () => {
        this.setState({ confirmLogoutDialogOpen: true });
    };

    render() {
        const { menuAnchorEl } = this.state;
        const { cardCheckerCard, classes, theme } = this.props;

        const isMenuOpen = Boolean(menuAnchorEl);
        const isLoggedIn = Boolean(cardCheckerCard);

        const renderMenu = (
            <MediaQuery maxWidth={768}>
                {(matches) => (
                    <Menu
                        open={isMenuOpen}
                        anchorReference="none"
                        onClose={this.hideMenu}
                        PaperProps={{
                            style: {
                                right: 0,
                                top: matches ? appBarHeightSmall : appBarHeightLarge,
                                backgroundColor: theme.palette.secondary.dark,
                                color: theme.palette.primary.contrastText,
                                borderRadius: 0
                            }
                        }}>
                        <div className={classes.userNamePanel}>
                            <div className={classes.name}>
                                {isLoggedIn ? `${cardCheckerCard.firstname} ${cardCheckerCard.surname}` : ''}
                            </div>
                            <Body2 className={classes.number}>
                                {isLoggedIn ? cardCheckerCard.skillSafeNo : ''}
                            </Body2>
                        </div>
                        <Divider className={classes.menuDivider} />
                        <MenuItem
                            className={classes.menuItem}
                            onClick={this.clickDelegate(this.props.onShowCardClicked)}>
                            <ListItemIcon className={classes.menuItemIcon}>
                                <ShowCardIcon />
                            </ListItemIcon>
                            Show Card
                         </MenuItem>
                        <MenuItem
                            className={classes.menuItem}
                            onClick={this.clickDelegate(this.props.onLocationClicked)}>
                            <ListItemIcon className={classes.menuItemIcon}>
                                <LocationIcon />
                            </ListItemIcon>
                            Change Location
                        </MenuItem>
                        <MenuItem
                            className={classes.menuItem}
                            onClick={this.clickDelegate(this.props.onCompetencyRequirementsClicked)}>
                            <ListItemIcon className={classes.menuItemIcon}>
                                <CompetencyRequirementsIcon />
                            </ListItemIcon>
                            Location Requirements
                        </MenuItem>
                        <Divider className={classes.menuDivider} />
                        <MenuItem
                            className={classes.menuItem}
                            onClick={this.clickDelegate(this.openUserGuide)}>
                            <ListItemIcon className={classes.menuItemIcon}>
                                <UserGuideIcon />
                            </ListItemIcon>
                            RIW Knowledge Centre
                        </MenuItem>
                        <Divider className={classes.menuDivider} />
                        <MenuItem
                            className={classes.menuItem}
                            onClick={this.handleLogout}>
                            <ListItemIcon className={classes.menuItemIcon}>
                                <SignOutIcon />
                            </ListItemIcon>
                            Log Out
                        </MenuItem>
                    </Menu>
                )}
            </MediaQuery>
        );

        return (
            <div className={isMenuOpen ? classes.open : ''}>
                {isLoggedIn &&
                    <React.Fragment>
                        <PromptDialog
                            open={this.state.confirmLogoutDialogOpen}
                            handleClose={this.cancelLogout}
                            title="Confirm Logout"
                            message="Are you sure you want to log out?"
                            showCancel={true}
                            cancelClicked={this.cancelLogout}
                            confirmClicked={this.props.onLogOutClicked} />

                        <Grid container className={classes.root}>
                            <Grid item>
                                <IconButton onClick={this.showMenu} className={classes.avatarButton}>
                                    <Avatar className={classes.avatar} src={"data:image/png;base64," + cardCheckerCard.photo} alt="User photo" />
                                </IconButton>
                            </Grid>
                        </Grid>
                        {renderMenu}
                    </React.Fragment>
                }
            </div>
        );
    }
}

UserProfileHeader.propTypes = {
    onLogOutClicked: PropTypes.func.isRequired,
    onLocationClicked: PropTypes.func.isRequired,
    onShowCardClicked: PropTypes.func.isRequired,
    onCompetencyRequirementsClicked: PropTypes.func.isRequired,
    cardCheckerCard: PropTypes.object
};

export default withTheme(withStyles(styles)(UserProfileHeader));